export const types = {
    CLEAR_USER: 'CLEAR_USER',
    SET_USER_DATA: 'SET_USER_DATA',
    SET_PUBLISH: 'SET_PUBLISH',
    SET_UNPUBLISH: 'SET_UNPUBLISH',
    SET_CONNECTION_ERROR: 'SET_CONNECTION_ERROR',
    SET_SERVICE_ERROR: 'SET_SERVICE_ERROR'
};